import PropTypes from "prop-types";
import Pill from "../pill";

const Pills = (props) => {

	const {
		className, data, id, onClick, selected,
	} = props;

	return (
		<>
			<div
				id={id}
				className={`pills-wrapper${
					className ? ` ${className}` : ""
				}`}
			>
				{Array.isArray(data) && data?.map((dataPill) => (
					<Pill
						key={dataPill.value}
						id={dataPill.id}
						data={{ label: dataPill.label, value: dataPill.value }}
						onClick={onClick}
						labelFontClass={dataPill.labelFontClass}
						selected={dataPill.value === selected}
						disabled={dataPill.disabled}
					/>
				))}
			</div>

			<style>
				{`
					.pills-wrapper {
						width: 100%;
						height: fit-content;
						display: flex;
						flex-direction: row;
						column-gap: 8px;
						align-items: center;
						justify-content: start;
						overflow-y: hidden;
						overflow-x: auto;

						/* For common browsers that support WebKit (Chrome, Safari) */
						&::-webkit-scrollbar {
						display: none;
						}

						/* For Microsoft Edge based on Chromium */
						&::-ms-overflow-style {
						display: none;
						}

						/* For Microsoft Internet Explorer (IE) 11 */
						-ms-overflow-style: none;

						/* For Firefox */
						scrollbar-width: none;
					}
				`}
			</style>
		</>
	);

};

Pills.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			label: PropTypes.string,
			value: PropTypes.value,
			labelFontClass: PropTypes.string,
			disabled: PropTypes.bool,
		}),
	),
	onClick: PropTypes.func,
	selected: PropTypes.string,
};

Pills.defaultProps = {
	id: null,
	className: "",
	onClick: undefined,
	selected: undefined,
	data: undefined,
};

export default Pills;
